let script = null

export default {
  name: 'Vlibras',

  props: {
    opacity: {
      type: String,
      default: '0.5'
    },
    active: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      pluginSrc: '/lib/vlibras/vlibras-plugin.js',
      widgetSrc: '/lib/vlibras'
    }
  },

  watch: {
    active (val) {
      if (!val) {
        window.VLibras.Widget.CloseVlibras()
      } else {
        window.VLibras.Widget.OpenVlibras()
      }
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      script = document.createElement('script')
      script.addEventListener('load', this.createWidget)
      script.src = this.pluginSrc
      document.querySelector('body').appendChild(script)
    },

    createWidget () {
      script.removeEventListener('load', this.createWidget)
      // eslint-disable-next-line no-new
      new window.VLibras.Widget(this.widgetSrc, '', this.opacity)
    }
  }
}
